(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["si-becoming-club"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = field => {
    if (field.dataset.initialized) return;
    const root = field.closest('.si-chapter');
    const form = field.closest('form');
    if (!root || !form) return;
    const idInput = form.querySelector('[name="id"]');
    const quantity = form.querySelector('[name="quantity"]');
    if (!root || !idInput || !quantity) return;
    field.dataset.initialized = 'true';
    const planInput = field.querySelector('[data-club-plan-input]');
    const property = field.querySelector('[data-club-order-property]');
    const price = root.querySelector('.si-price');
    const perTattoo = root.querySelector('.si-per-tattoo');
    const oncePriceText = price.textContent;
    const oncePerText = perTattoo.textContent;
    const stickyCopy = root.querySelector('.si-sticky span:not([data-total])');
    const onceSticky = stickyCopy ? stickyCopy.textContent : '';
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:root.dataset.currency || 'USD'});
    const previewOnly = field.dataset.preview === 'true';
    const submitButtons = [...root.querySelectorAll('button[type="submit"]')].map(button => ({button,disabled:button.disabled}));
    let savedQuantity = quantity.value;
    let wasClub = false;
    const apply = () => {
      const isClub = field.querySelector('input[type="radio"]:checked').value === 'club';
      if (isClub && !wasClub) savedQuantity = quantity.value;
      if (!isClub && wasClub) quantity.value = savedQuantity;
      wasClub = isClub;
      root.dataset.clubSelected = String(isClub);
      field.querySelector('[data-club-first]').hidden = !isClub;
      idInput.value = isClub && !previewOnly ? field.dataset.clubId : field.dataset.onceId;
      submitButtons.forEach(({button,disabled}) => { button.disabled = disabled || (isClub && previewOnly); });
      planInput.disabled = !isClub || previewOnly;
      planInput.value = isClub && !previewOnly ? field.dataset.clubPlan : '';
      property.value = isClub ? 'chapters_club' : 'one_time';
      root.dataset.price = isClub ? field.dataset.clubPrice : field.dataset.oncePrice;
      quantity.readOnly = isClub;
      root.querySelectorAll('[data-quantity]').forEach(button => { button.disabled = isClub; });
      if (isClub) quantity.value = '1';
      price.textContent = isClub ? formatter.format(Number(field.dataset.clubPrice) / 100) : oncePriceText;
      perTattoo.textContent = isClub ? formatter.format(Math.round(Number(field.dataset.clubPrice) / 24) / 100) + ' ' + field.dataset.perTattoo : oncePerText;
      if (stickyCopy) stickyCopy.textContent = isClub ? field.dataset.clubSticky : onceSticky;
      root.querySelectorAll('[data-total]').forEach(el => { el.textContent = formatter.format(Number(root.dataset.price) * Number(quantity.value) / 100); });
      quantity.dispatchEvent(new Event('change', {bubbles:true}));
    };
    field.querySelectorAll('input[type="radio"]').forEach(input => input.addEventListener('change',apply));
    form.addEventListener('submit', event => {
      if (wasClub && (previewOnly || idInput.value !== field.dataset.clubId || planInput.disabled || planInput.value !== field.dataset.clubPlan || quantity.value !== '1')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        apply();
        window.alert(field.dataset.error);
      }
    },true);
    apply();
    field.hidden = false;
    window.addEventListener('pageshow',apply);
  };
  const mount = scope => scope.querySelectorAll('[data-becoming-club]').forEach(init);
  mount(document);
  document.addEventListener('shopify:section:load',event => mount(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["spectrum-product-rating"] && !Shopify.designMode) return;
  try {
    // Clicking a Loox badge on its own product page scrolls to its review widget.
// Lives with the badge (not a section) so it works on every template the badge is on.
(function () {
  if (window.__siLooxRatingScroll) return;
  window.__siLooxRatingScroll = true;
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-loox-product-rating]') : null;
    if (!a || a.origin !== window.location.origin || a.pathname !== window.location.pathname) return;
    var t = document.getElementById(a.hash.slice(1));
    if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  }, false);
})();
  } catch(e) { console.error(e); }
})();

})();
